import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import BlogCategoryForm from "./BlogCategoryForm";

import { getBlogById, updateBlog } from "../../api/BlogCategoryService";

const BlogCategoryedit = () => {
  const location = useLocation();

  const id = location.state?.blogId;
  const slug = location.state?.slug;
  const navigate = useNavigate();

  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await getBlogById(slug);

      setCategory({
        _id: res.data._id,
        name: res.data.name || "",
        description: res.data.description || "",
        status: res.data.status || "ACTIVE",
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      setErrors({});

      const payload = {
        name: values.name,
        description: values.description,
        status: values.status,
      };

      const res = await updateBlog(id, payload);

      if (res.success) {
        navigate("/blogcategory");
      }
    } catch (error) {
      console.error("UPDATE ERROR:", error);

      if (error?.response?.data?.error) {
        setErrors(error.response.data.error);
      }
    } finally {
      setLoading(false);
    }
  };

  if (!category) return <p>Loading...</p>;

  return (
    <BlogCategoryForm
      category={category}
      initialValues={category}
      onSubmit={handleSubmit}
      loading={loading}
      errors={errors}
      onCancel={() => navigate("/blogcategory")}
    />
  );
};

export default BlogCategoryedit;
